export const LIST_ITEM_HEIGHT = 50;
export function getY(p: Positions, id: string) {
  "worklet";
  return p[id] * LIST_ITEM_HEIGHT;
}

export const getOrder = (ty: number) => {
  "worklet";
  const y = Math.round(ty / LIST_ITEM_HEIGHT) * LIST_ITEM_HEIGHT;
  const row = Math.max(y, 0) / LIST_ITEM_HEIGHT;
  return row;
};

export type Positions = { [id: string]: number };
